import * as R from 'ramda';
import {ValidateFunction} from './validate-fns';

export type Validator = (value: any) => string | undefined;

const createValidator = R.curry(
  (validateFn: ValidateFunction, errorMessage: any, value: any) =>
    validateFn(value) === undefined ? undefined : errorMessage
);

const composeValidators = R.curry((validateFns: Validator[], value: any) =>
  R.reduce<any, string | undefined>(
    (acc, validateFn) => (acc ? acc : validateFn(value)),
    undefined,
    validateFns
  )
);

const applyIfNotEmpty = R.curry((fn: Validator, value: any) => {
  const isNotEmpty = Array.isArray(value) ? !!value.length : !!value;

  if (isNotEmpty) {
    return fn(value);
  }
  return undefined;
});

export {createValidator, composeValidators, applyIfNotEmpty};
